
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(055|402|510)|3(145|364|688|993)|1897|4074|4507|5988|836)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
